import React from 'react'
import PropTypes from 'prop-types'
import cs from 'classnames'
import styles from './divider.module.css'

const Divider = ({ fullWidth = true }) => (
  <hr className={cs(styles.Divider, !fullWidth && styles.notFull)} />
)

Divider.propTypes = {
  fullWidth: PropTypes.bool,
}

export default Divider
